<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content [innerHTML]="data.message">
</div>
<div mat-dialog-actions class="flex-container-row">
  <button style="flex: auto;" mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
  <button style="flex: auto;" mat-raised-button [mat-dialog-close]="false">No</button>
</div>